export const baseUrl = " https://pixelisapp.com/backend/public";